module.exports = __webpack_public_path__ + "static/media/triangle-down.4b02a4b2.svg";